/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PoolSearchDto interface.
 */
export function instanceOfPoolSearchDto(value) {
    if (!('poolName' in value) || value['poolName'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('artist' in value) || value['artist'] === undefined)
        return false;
    return true;
}
export function PoolSearchDtoFromJSON(json) {
    return PoolSearchDtoFromJSONTyped(json, false);
}
export function PoolSearchDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'poolName': json['poolName'],
        'title': json['title'],
        'artist': json['artist'],
        'trackId': json['trackId'] == null ? undefined : json['trackId'],
    };
}
export function PoolSearchDtoToJSON(json) {
    return PoolSearchDtoToJSONTyped(json, false);
}
export function PoolSearchDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'poolName': value['poolName'],
        'title': value['title'],
        'artist': value['artist'],
        'trackId': value['trackId'],
    };
}
